export default {
  admin: [
    {
      action: ["show"],
      subject: ["SideBar"]
    }
  ],
  client_root: [
    {
      action: ["show"],
      subject: ["SideBar"]
    }
  ],
  client_sub: [
    {
      action: ["show"],
      subject: ["SideBar"]
    }
  ]
};
